export class PaymentDTO {
  constructor({ demandId, extraId, paymentId, type, upfront, paymentToken } = {}) {
    this.demandId = demandId;
    this.extraId = extraId;
    this.paymentId = paymentId;
    this.type = type;
    this.upfront = upfront;
    this.paymentToken = paymentToken;
  }

  preparePaymentWithCreditData() {
    return {
      id_demande: this.demandId,
      extra_id: this.extraId,
    };
  }

  prepareSelectWithoutCardData() {
    return {
      id_demande: this.demandId,
      extra_id: this.extraId,
    };
  }

  prepareConfirmPaymentData() {
    return {
      paymentId: this.paymentId,
      type: this.type,
      misEnAvant: this.upfront,
    };
  }

  preparePaymentData() {
    return {
      paymentToken: this.paymentToken,
      type: this.type,
      misEnAvant: this.upfront,
    };
  }
}
